import React from 'react'
import './contact.css'
import{MdOutlineEmail} from 'react-icons/md'
import { CiLinkedin } from "react-icons/ci";
import  { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    console.log(process.env.REACT_APP_EMAILJS_SERVICE_ID);
    console.log(process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
    console.log(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

    emailjs
      .sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, form.current, {
        publicKey:  process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },

        e.target.reset()
      );
  };
  return (
    <section id='contact'>
      <h5> Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact_container'>
        <div className="contact_options">
          <article className="contact_option">
            <MdOutlineEmail className='contact_option-icon'/>
            <h4>Email</h4>
            <h5>chiekuma24@gmail.com</h5>
            <a href="mailto:chiekuma24@gmail.com" target= "_blank" rel="noreferrer"> Send a Message</a>
          </article>

          <article className="contact_option">
              <CiLinkedin className='contact_option-icon'/>
              <h4>LinkedIn</h4>
              <h5>Chidinma Ekuma</h5>
              <a href="https://linkedin.com/in/chidinma-ekuma" target= "_blank" rel="noreferrer"> Send a Message</a>
            </article>

        </div>
        
        {/* END OF CONTACT  OPTIONS */}
        
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name="email" placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
      
    </section>
  )
}

export default Contact
